import Banking from './Banking';
export default Banking;